import axios from 'axios';
import { convertQuestionsToArray } from '../../../../components/CASAForm/Utilities';
import { addFormSubmissionFailed } from '../../FormPropertyAction/FormPropertyAction';

export const REQUEST_CLOSE_SUBMISSION_CRM_ACTION_BEGIN = 'REQUEST_CLOSE_SUBMISSION_CRM_ACTION_BEGIN';
export const REQUEST_CLOSE_SUBMISSION_CRM_ACTION_SUCCESS = 'REQUEST_CLOSE_SUBMISSION_CRM_ACTION_SUCCESS';
export const REQUEST_CLOSE_SUBMISSION_CRM_ACTION_FAILURE = 'REQUEST_CLOSE_SUBMISSION_CRM_ACTION_FAILURE';

export const requestCloseSubmissionCrmActionBegin = () => ({
    type: REQUEST_CLOSE_SUBMISSION_CRM_ACTION_BEGIN
});

export const requestCloseSubmissionCrmActionSuccess = (value) => ({
    type: REQUEST_CLOSE_SUBMISSION_CRM_ACTION_SUCCESS,
    payload: value
});

export const requestCloseSubmissionCrmActionFailure = (error) => ({
    type: REQUEST_CLOSE_SUBMISSION_CRM_ACTION_FAILURE,
    payload: error
});

export const requestCloseSubmissionCrmAction = (webappurlForms, accessToken, formProperties, formData, submissionId, cancellationReason, caseNumber) => {
    return dispatch => {
        const options = {
            headers: {
                'Authorization': "Bearer " + accessToken,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        const data = {
            "rootFormCode": formProperties.rootFormCode,
            "formCode": formProperties.formCode,
            "formData": {
                "steps": convertQuestionsToArray(formData.steps),
                "submissionId": submissionId,
                "cancellationReason": cancellationReason,
                "transactionId": caseNumber !== "N/A" ? caseNumber : ""
            },
            "name": formProperties.name,
            "version": formProperties.version,
            "orgid": formProperties.orgid,
            "organisationArn": formProperties.organisationArn
        }

        dispatch(requestCloseSubmissionCrmActionBegin());
        return axios.post(webappurlForms + `/api/myCASA/Forms/Submissions/${submissionId}/Cancel/v1`, data, options)
            .then(response => {
                if (response.data.wasSuccessful) {
                    response.data.submissionPortalName = "Notification of Fireworks Display";
                    response.data.submissionStatus = "New";
                    response.data.caseNumber = "123456";
                    return dispatch(requestCloseSubmissionCrmActionSuccess(response.data.submission));
                }
                else {
                    dispatch(addFormSubmissionFailed())
                    return dispatch(requestCloseSubmissionCrmActionFailure(response.data.errors));
                }
            })
            .catch(error => {
                dispatch(addFormSubmissionFailed())
                return dispatch(requestCloseSubmissionCrmActionFailure(error?.response?.data.errors ?? error));
            });
    };
}
